<template>
    <div class="section-heading">
        <row>
            <column fluid>
                <h4
                    class="section-heading__text"
                    v-text="text"
                />
                <p
                    v-if="subText"
                    class="section-heading__sub-text"
                    v-text="subText"
                />
            </column>
            <column v-if="hasSlotData" shrink>
                <slot />
            </column>
        </row>
    </div>
</template>

<script>
    /**
    * Component
    */
    export default {
        name: 'section-heading',
        props: {
            text: {
                type: String,
                required: true
            },
            subText: {
                type: String,
                required: false
            }
        },
        computed: {
            hasSlotData () {
                return Object.keys(this.$slots).length > 0
            }
        }
    }
</script>

<style lang="scss">
    .section-heading {
        border-bottom: 1px solid #d8d8d8;
        margin: 0 0 30px 0;
        padding: 0 0 30px 0;

        &__text {
            font-size: 22px;
            line-height: 1;
            margin: 0;
        }

        &__sub-text {
            margin: 30px 0 0 0;
            font-size: 14px;
            color: #666;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/SectionHeading.vue